import { graphql, useFragment } from "react-relay";
import { Box } from "arkh";
import { useCallback } from "react";
import { TeamScheduleSectionHeaderStatusDot } from "../Team/TeamHomeNavigator/TeamSchedule/TeamScheduleHeader/TeamScheduleSectionHeaderStatusDot";
import { TeamScheduleStatusRow_teamScheduleEventOccasion$key } from "./__generated__/TeamScheduleStatusRow_teamScheduleEventOccasion.graphql";

export function TeamScheduleStatusRow(props: {
  teamSchedule: TeamScheduleStatusRow_teamScheduleEventOccasion$key;
}) {
  const events = useFragment(
    graphql`
      fragment TeamScheduleStatusRow_teamScheduleEventOccasion on TeamScheduleEventOccasion
      @relay(plural: true) {
        ... on RoutineOccasion {
          ...TeamScheduleSectionHeaderStatusDot_routineOccasion
        }
        ... on TeamScheduleInlineRoutineOccasion {
          taskExecution {
            routineOccasion {
              ...TeamScheduleSectionHeaderStatusDot_routineOccasion
            }
          }
        }
      }
    `,
    props.teamSchedule
  );

  const routineOccasions = events.flatMap(
    (event) => event.taskExecution?.routineOccasion ?? event
  );

  const renderStatus = useCallback(
    (occasion: (typeof routineOccasions)[number], index: number) => (
      <Box spaceLeft="xxsmall" spaceBottom="xxsmall" key={index}>
        <TeamScheduleSectionHeaderStatusDot occasion={occasion} />
      </Box>
    ),
    []
  );
  return (
    <Box
      spaceTop="xsmall"
      style={{
        flexDirection: "row",
        alignItems: "center",
        overflow: "hidden",
        flexWrap: "wrap",
      }}
    >
      {routineOccasions.slice(0, 31).map(renderStatus)}
    </Box>
  );
}
